export default __webpack_public_path__ + "static/media/Pose.89132eda.svg";